<div class="content-body">
  <div class="question">Q: Is there a way to manage Notes all at once?</div>
  <div class="description"> 
    <ul> 
      <li>If you want to view the list of Directions and Notes across all sites, go to <span class="link" (click)="goToReport()">'Reports > Site Notes Manager.' </span></li>
      <li>Here, you can see the list of all sites you manage along with their Site Notes and Monitoring Directions, and you can add new ones if necessary.</li>
    </ul>
  </div>
</div>